import { Route } from '@angular/router';

import { AuthGuard } from './services/auth.guard';
import { PermissionGuard } from './services/permission.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./auth/signin').then((m) => m.SigninComponent),
  },
  {
    path: 'signin',
    loadComponent: () => import('./auth/signin').then((m) => m.SigninComponent),
  },
  {
    path: 'download-soa/:shareId',
    loadComponent: () =>
      import('./statement/shared-download.component').then(
        (m) => m.SharedDownloadComponent,
      ),
  },
  {
    path: 'app',
    loadComponent: () =>
      import('./layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'new-loan',
        loadComponent: () =>
          import('./new-loan/new-loan.component').then(
            (m) => m.NewLoanComponent,
          ),
      },
      {
        path: 'compare-tool',
        loadComponent: () =>
          import('./dashboard/components/loan-comparison/loan-comparison.component').then(
            (m) => m.LoanComparisonComponent,
          ),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./reports/reports.component').then((m) => m.ReportsComponent),
        canActivate: [PermissionGuard],
        data: { permissions: ['REPORT_VIEW'] },
      },
      {
        path: 'statement',
        loadComponent: () =>
          import('./statement/statement.component').then(
            (m) => m.StatementComponent,
          ),
        canActivate: [PermissionGuard],
        data: { permissions: ['SOA_VIEW'] },
      },
      {
        path: 'noc',
        loadComponent: () =>
          import('./noc/noc.component').then((m) => m.NocComponent),
        canActivate: [PermissionGuard],
        data: { permissions: ['NOC_VIEW'] },
      },
      {
        path: 'loan/:loanId',
        loadComponent: () =>
          import('./dashboard/components/loan-schedule-modal/loan-schedule-modal.component').then(
            (m) => m.LoanScheduleModalComponent,
          ),
        data: { pageMode: true },
      },
    ],
  },
];
